module.exports = __webpack_public_path__ + "img/month_5_icon.b1bea2ef.png";